// Imports
import { transparentize } from 'polished';
import theme from '../../../theme';


// Define the accepted parameters
interface StripeAppearanceConfig {
	primaryColor: string;
	fontFamily?: string;
}


/** Generates a configuration for Stripe's appearance API */
const generateStripeAppearance = ({ primaryColor, fontFamily }: StripeAppearanceConfig) => ({
	variables: {
		...(fontFamily ? { fontFamily } : {}),
		spacingUnit: '0.1875rem',
		spacingGridRow: '1.25rem',
		borderRadius: '0.25rem',
		colorPrimary: primaryColor,
		colorDanger: theme.colors.danger,
		focusBoxShadow: `0 0 0 0.125em ${transparentize(0.75, primaryColor)}`,
	},
	rules: {
		'.Label': {
			fontSize: '1rem',
			fontWeight: '600',
			color: '#363636',
			lineHeight: '1',
			paddingBottom: '0.3em',
			marginBottom: '0.2rem',
		},
		'.Input, .AccordionItem, .PickerItem, .PickerItem--selected': {
			boxShadow: 'none',
			borderColor: '#ddd',
		},
		'.Input:focus': {
			boxShadow: `0 0 0 0.125em ${transparentize(0.75, primaryColor)}`,
		},
		'.Input--invalid': {
			boxShadow: 'none',
		},
	},
});

export default generateStripeAppearance;
